const roles: any = {};
roles[process.env.REACT_APP_SUPER_USER_ROLE as any] = "SuperUser";
roles[process.env.REACT_APP_ADMIN_ROLE as any] = "Admin";
roles[process.env.REACT_APP_SUPER_ADMIN_ROLE as any] = "SuperAdmin";

export default roles;
